export const GET_FUNDING_SOURCE_SETTINGS_DATA_REQUEST = "GET_FUNDING_SOURCE_SETTINGS_DATA_REQUEST";
export const GET_FUNDING_SOURCE_SETTINGS_DATA_SUCCESS = "GET_FUNDING_SOURCE_SETTINGS_DATA_SUCCESS";
export const GET_FUNDING_SOURCE_SETTINGS_DATA_FAILURE = "GET_FUNDING_SOURCE_SETTINGS_DATA_FAILURE";

export const ADD_FUNDING_SOURCE_REQUEST = "ADD_FUNDING_SOURCE_REQUEST";
export const ADD_FUNDING_SOURCE_SUCCESS = "ADD_FUNDING_SOURCE_SUCCESS";
export const ADD_FUNDING_SOURCE_FAILURE = "ADD_FUNDING_SOURCE_FAILURE";

export const GET_FUNDING_SOURCE_BY_ID_REQUEST = "GET_FUNDING_SOURCE_BY_ID_REQUEST";
export const GET_FUNDING_SOURCE_BY_ID_SUCCESS = "GET_FUNDING_SOURCE_BY_ID_SUCCESS";
export const GET_FUNDING_SOURCE_BY_ID_FAILURE = "GET_FUNDING_SOURCE_BY_ID_FAILURE";

export const UPDATE_FUNDING_SOURCE_REQUEST = "UPDATE_FUNDING_SOURCE_REQUEST";
export const UPDATE_FUNDING_SOURCE_SUCCESS = "UPDATE_FUNDING_SOURCE_SUCCESS";
export const UPDATE_FUNDING_SOURCE_FAILURE = "UPDATE_FUNDING_SOURCE_FAILURE";

export const DELETE_FUNDING_SOURCE_REQUEST = "DELETE_FUNDING_SOURCE_REQUEST";
export const DELETE_FUNDING_SOURCE_SUCCESS = "DELETE_FUNDING_SOURCE_SUCCESS";
export const DELETE_FUNDING_SOURCE_FAILURE = "DELETE_FUNDING_SOURCE_FAILURE";

// Update Floor Entity Param
export const UPDATE_FUNDING_SOURCE_ENTITY_PARAMS_SUCCESS = "UPDATE_FUNDING_SOURCE_ENTITY_PARAMS_SUCCESS";
export const UPDATE_FUNDING_SOURCE_ENTITY_PARAMS_FAILURE = "UPDATE_FUNDING_SOURCE_ENTITY_PARAMS_FAILURE";

export const GET_LIST_FOR_COMMON_FILTER_REQUEST = "GET_LIST_FOR_COMMON_FILTER_REQUEST";
export const GET_LIST_FOR_COMMON_FILTER_SUCCESS = "GET_LIST_FOR_COMMON_FILTER_SUCCESS";
export const GET_LIST_FOR_COMMON_FILTER_FAILURE = "GET_LIST_FOR_COMMON_FILTER_FAILURE";

export const GET_ALL_FUNDING_SOURCE_LOG_REQUEST = "GET_ALL_FUNDING_SOURCE_LOG_REQUEST";
export const GET_ALL_FUNDING_SOURCE_LOG_SUCCESS = "GET_ALL_FUNDING_SOURCE_LOG_SUCCESS";
export const GET_ALL_FUNDING_SOURCE_LOG_FAILURE = "GET_ALL_FUNDING_SOURCE_LOG_FAILURE";

export const RESTORE_SETTINGS_LOG_REQUEST = "RESTORE_SETTINGS_LOG_REQUEST";
export const RESTORE_SETTINGS_LOG_SUCCESS = "RESTORE_SETTINGS_LOG_SUCCESS";
export const RESTORE_SETTINGS_LOG_FAILURE = "RESTORE_SETTINGS_LOG_FAILURE";

export const DELETE_SETTINGS_LOG_REQUEST = "DELETE_SETTINGS_LOG_REQUEST";
export const DELETE_SETTINGS_LOG_SUCCESS = "DELETE_SETTINGS_LOG_SUCCESS";
export const DELETE_SETTINGS_LOG_FAILURE = "DELETE_SETTINGS_LOG_FAILURE";

export const GET_FUNDING_SOURCE_EXPORT_REQUEST = "GET_FUNDING_SOURCE_EXPORT_REQUEST";
export const GET_FUNDING_SOURCE_EXPORT_SUCCESS = "GET_FUNDING_SOURCE_EXPORT_SUCCESS";
export const GET_FUNDING_SOURCE_EXPORT_FAILURE = "GET_FUNDING_SOURCE_EXPORT_FAILURE";
